angular
  .module('library')

  .factory('AcquisitionSourcesCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class AcquisitionSourcesCrud extends Crud {
        constructor(list) {
          super(
            'acquisition-sources' + (list || ''),
            '@@apiUrl' + '/acquisition-sources' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return AcquisitionSourcesCrud;
    }
  ]);
